import { __currentUser__ } from "../graphql/policies";
import { MarketType } from "../types/types";

export default function getInitialMarket(): MarketType {
  const { afUserMarkets } = __currentUser__() || {};
  const markets = afUserMarkets?.map((item) => item?.market) ?? "HK";

  return markets ? (markets[0] as MarketType) || "HK" : "HK";
}
